// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI, { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueRouter from 'vue-router'
import routes from './base/router'
import store from './vuex/store'
import Vuex from 'vuex'
import i18n from '@/message/i18n.js'
import '@/statics/css/site.css'
import VueCookies from 'vue-cookies'
import iconfont from '@/statics/icon/iconfont'
import fileIcon from '@/statics/fileIcon/iconfont'
import 'swiper/swiper-bundle.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueTabsSwipe from 'vue-tabs-swiper'
// 引入自定义插件
import plugin from '@/common/plugin'
Vue.config.productionTip = false

Vue.use(VueTabsSwipe)
Vue.use(VueAwesomeSwiper)
// 在Vue中全局使用mintui
Vue.use(ElementUI)
Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VueCookies)
Vue.use(iconfont)
Vue.use(fileIcon)
// 在Vue中全局使用自定义插件
Vue.use(plugin)
//  将vue-resource在vue中绑定，自动在vue对象实例上注入一个$http对象就可以使用ajax方法了
import vueResource from 'vue-resource';
Vue.use(vueResource)
/* eslint-disable no-new */
const router = new VueRouter({
  mode: 'history',
  // change url by qiujing 20200228
  base: '/amsMobAttWeb/',
  //base: '/amsMoAttWeb/',
  routes
})

//全局实现避免消息提示多次弹出
// 为了实现Class的私有属性
const showMessage = Symbol('showMessage')
/**
 *  重写ElementUI的Message
 *  single默认值true，因为项目需求，默认只弹出一个，可以根据实际需要设置
 */
class DonMessage {
  success(options, single = true) {
    this[showMessage]('success', options, single)
  }
  warning(options, single = true) {
    this[showMessage]('warning', options, single)
  }
  info(options, single = true) {
    this[showMessage]('info', options, single)
  }
  error(options, single = true) {
    this[showMessage]('error', options, single)
  }

  [showMessage](type, options, single) {
    if (single) {
      // 判断是否已存在Message
      if (document.getElementsByClassName('el-message').length === 0) {
        Message[type](options)
      }
    } else {
      Message[type](options)
    }
  }
}
// 命名根据需要，DonMessage只是在文章中使用
Vue.prototype.$message = new DonMessage()
router.beforeEach((to, from, next) => {
  if (to.meta.name || to.name != null) {
    let routeName = (to.meta.name || to.name).split('>')
    routeName = routeName[routeName.length - 1]
    window.document.title = (routeName ? routeName + ' - ' : '') + 'RMSAスタッフアプリ';
    next();
  } else {
    window.document.title = 'RMSAスタッフアプリ';
  }
});

Vue.prototype.$message.close = function (id, userOnClose) {
  return ElementUI.Message.close(id, userOnClose);
}
Vue.prototype.$message.closeAll = function () {
  return ElementUI.Message.closeAll();
}

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: c => c(App)
})




// WEBPACK FOOTER //
// ./src/main.js